// extracted by mini-css-extract-plugin
export default {"imageWrapper":"CryptoPage_imageWrapper__-VnS+","fieldGroup":"CryptoPage_fieldGroup__QBTFI"};